package module

import com.tencent.kuikly.core.render.web.export.KuiklyRenderBaseModule
import com.tencent.kuikly.core.render.web.ktx.KuiklyRenderCallback

/**
 * H5 侧 DevModule 实现
 * 通过 URL hostname 判断是否为开发环境
 * - localhost / 127.0.0.1 → Dev 模式
 * - 正式域名 → 生产模式
 */
class KRDevModule : KuiklyRenderBaseModule() {

    override fun call(method: String, params: String?, callback: KuiklyRenderCallback?): Any? {
        return when (method) {
            "isDevMode" -> isDevMode()
            else -> null
        }
    }

    private fun isDevMode(): String {
        val hostname = kotlinx.browser.window.location.hostname
        val isDev = hostname == "localhost" ||
                hostname == "127.0.0.1" ||
                hostname.startsWith("192.168.") ||
                hostname.startsWith("dev.") ||
                hostname.endsWith(".local")
        return if (isDev) "1" else "0"
    }

    companion object {
        const val MODULE_NAME = "KRDevModule"
    }
}
